'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Listbox": "Polaris-Combobox__Listbox"
};

exports.default = styles;
